<script setup lang="ts">
/** [#e03fdbc2] Партнёрская программа: приводите клиентов, получайте выплату с устройства. */
import { ArrowRight, Check, ChevronRight } from 'lucide-vue-next';
import ContactBlock from './landing/ContactBlock.vue';
import PublicShell from './landing/PublicShell.vue';
import { usePublicPage } from './landing/usePublicPage';

const { copy, more, to } = usePublicPage();
</script>

<template>
  <PublicShell>
    <main>
      <div class="lp-wrap lp-page lp-page--top">
        <nav class="lp-crumbs" :aria-label="copy.articles.home">
          <RouterLink :to="to('/')">{{ copy.articles.home }}</RouterLink>
          <ChevronRight :size="14" /><span>{{ more.nav.partners }}</span>
        </nav>
        <header class="lp-page-head">
          <h1>{{ more.partners.title }}</h1>
          <p>{{ more.partners.sub }}</p>
        </header>
        <a href="#contact" class="lp-btn lp-btn--primary">{{ more.partners.cta }}<ArrowRight :size="17" /></a>
      </div>
      <section class="lp-section lp-section--tint">
        <div class="lp-wrap">
          <header class="lp-head"><h2>{{ more.partners.stepsTitle }}</h2></header>
          <ol class="lp-three">
            <li v-for="(s, i) in more.partners.steps" :key="s.title" class="lp-card"><span class="lp-num">{{ i + 1 }}</span><h3>{{ s.title }}</h3><p>{{ s.text }}</p></li>
          </ol>
        </div>
      </section>
      <section class="lp-section lp-wrap lp-narrow">
        <header class="lp-head"><h2>{{ more.partners.whoTitle }}</h2></header>
        <ul class="lp-list">
          <li v-for="w in more.partners.who" :key="w" class="lp-row lp-row--static"><Check :size="18" class="lp-check" /><div class="lp-grow"><h3>{{ w }}</h3></div></li>
        </ul>
        <div class="lp-pair lp-pair--one"><div class="lp-card"><h3>{{ more.partners.termsTitle }}</h3><p>{{ more.partners.termsText }}</p></div></div>
      </section>
      <ContactBlock :title="more.contactPartner.title" :sub="more.contactPartner.sub" :button="more.partners.cta" />
    </main>
  </PublicShell>
</template>
